<template>
<a-spin :spinning="spinning" tip="Loading...">
    <div class="card mb-3">
        <img style="display: none;" id='reportLogo' crossorigin="Anonymous" src='https://bxi-upload-bucket.s3.ap-southeast-1.amazonaws.com/iripple-images/reports/iripple/1646293427892_report_logo.png' alt='Report Logo'>
        <div class="row no-gutters">
            <div class="col-md-12" style="border-right: 1px solid #e0e0e0">
                <div class="card-body">
                    <div class="row">
                        <div class="col-md-4">
                            <base-input alternative="" label="From"><br>
                                <a-range-picker v-model="inputDate" :showTime="{ format: 'hh:mm' }" format="MM/DD/YYYY hh:mm A" :placeholder="['Start Time', 'End Time']" style="width:100%"/>
                            </base-input>
                        </div>
                    </div>
                    
                    <div class="row">
                        <div class="col-md-4">
                            <base-input label="Group By" >
                                <select class="form-control" v-model="inputGroupBy">
                                    <option v-for="option in groupOptions" v-bind:value="option.key" v-bind:key="option.key">
                                        {{ option.value }}
                                    </option>
                                </select>
                            </base-input>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-md-4">
                            <base-input alternative="" label="Select Site">
                                <a-select mode="multiple" v-model="inputSite" showSearch placeholder="All Sites" optionFilterProp="children" style="width: 100%" :filterOption="filterOption" :disabled="site_type != 'ho'">
                                    <a-select-option v-for="option in siteOptions" :key="option.id" :value="option.id">{{option.name}}</a-select-option>
                                </a-select>
                            </base-input>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-md-4">
                            <base-input label="Activity Type" >
                                <select class="form-control" v-model="inputTrans">
                                    <option v-for="option in transOptions" v-bind:value="option.key" v-bind:key="option.key">
                                        {{ option.value }}
                                    </option>
                                </select>
                            </base-input>
                        </div>
                    </div>
                    
                    <div class="row">
                        <div class="col-md-12">
                            <br>
                            <button class="btn btn-sm btn-default float-right" style="border-radius: 24px; border:0px; width: 20%;" @click.prevent="generateReport">Generate Report in PDF</button> &nbsp; &nbsp;
                            <button v-if="JsonData.length < 1" class="btn btn-sm btn-default float-right" style="border-radius: 24px; border:0px; width: 20%;" @click.prevent="generateFile">Generate Report</button> &nbsp; &nbsp;
                            <vue-json-to-csv v-if="JsonData.length > 0"  :json-data="JsonData" :csv-title="currentProfile.replace(/_/g, '-')+'-'+currDate.replace(/ /g, '_')">
                                <button id='clickCsvExport' class="btn btn-sm btn-success float-right" style="border-radius: 24px; border:0px; width: 20%;"> Download CSV </button> &nbsp; &nbsp;
                            </vue-json-to-csv>
                            <download-excel v-if="JsonData.length > 0" :data="JsonData" :name="currentProfile.replace(/_/g, '-')+'-'+currDate.replace(/ /g, '')+`.xls`" class="float-right"  style=" width: 20%;">
                                <button class="btn btn-sm btn-success" style="border-radius: 24px; border:0px; width: 100%;" @click.prevent="clearJsonData"> Download excel </button> &nbsp; &nbsp;
                            </download-excel>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</a-spin>
</template>

<script>
    import HTTPRequest from '../../controllers/httpRequest.js'
    import secureStorage from '../../controllers/secureStorage';
    import moment from 'moment';
    import jsPDF from 'jspdf';
    import 'jspdf-autotable';
    import VueJsonToCsv from 'vue-json-to-csv';
    import reportUtils from '../../components/reportUtils'

    import {
        mapState
    } from 'vuex'

    export default {
        data() {
            return {
                spinning: false,
                inputDate: [moment().startOf('day'), moment().endOf('day')],
                inputGroupBy: 'terminal_id',
                groupOptions: [
                    {key: 'terminal_id', value: 'Terminal'},
                    {key: 'user_id', value: 'Cashier'},
                    {key: 'session_id', value: 'Session'}
                ],
                inputTrans: 'ADD',
                transOptions: [
                    {key: 'ADD', value: 'Add Item'},
                    {key: 'ATL', value: 'At The Moment'},
                    {key: 'CUS', value: 'Customer'},
                    {key: 'DEC', value: 'Declarations'},
                    {key: 'DEP', value: 'Deposit'},
                    {key: 'EDIS', value: 'Exceed Discount Threshold'},
                    {key: 'FLT', value: 'Float'},
                    {key: 'IDC', value: 'Item Discount'},
                    {key: 'LVD', value: 'Line Void'},
                    {key: 'OPD', value: 'Open Department'},
                    {key: 'ODIS', value: 'Overall Discount'},
                    {key: 'PAY', value: 'Payment'},
                    {key: 'ACT', value: 'PNSTM Discount'},
                    {key: 'OVR', value: 'Price Override'},
                    {key: 'PWD', value: 'PWD Discount'},
                    {key: 'RES', value: 'Resume'},
                    {key: 'RET', value: 'Return'},
                    {key: 'RPN', value: 'Reprint'},
                    {key: 'RXR', value: 'Reprint X Reading'},
                    {key: 'RZR', value: 'Reprint Z Reading'},
                    {key: 'SAL', value: 'Sales'},
                    {key: 'SCD', value: 'SC Discount'},
                    {key: 'SCN', value: 'Scan Item'},
                    {key: 'SOF', value: 'Sign Off'},
                    {key: 'SON', value: 'Sign On'},
                    {key: 'SUS', value: 'Suspend'},
                    {key: 'SYN', value: 'Sync'},
                    {key: 'TMI', value: 'To Manual Invoice'},
                    {key: 'TVD', value: 'Transaction Void'},
                    {key: 'WIT', value: 'Withdrawal'},
                    {key: 'XRD', value: 'X Reading'},
                    {key: 'ZRD', value: 'Z Reading'}
                ],
                currDate: moment().format("L_LT").split(":").join(";"),
                inputSite: [],
                site_type: "ho",
                siteOptions: [],
                birSalesReports: [],
                JsonData: [],
                paymentTypeData: [],
                transCodeWithoutSupervisorOverride: ['SUS', 'RES', 'RET', 'DEC', 'SOF', 'SON', 'EDIS', 'SCD', 'ACT', 'PWD', 'SAL'],

            }
        },
        mounted: async function () {
            var component_x = this;

            var userId = secureStorage.getItem("userId")
            var sites = await HTTPRequest.getRequest(component_x.endPoint + "sites/get_valid_sites?user_id=" + userId, null);
            component_x.siteOptions = sites;
            component_x.sort(component_x.siteOptions);

            let siteId = secureStorage.getItem("defaultSiteId")
            this.inputSite = [siteId]

            let site = await HTTPRequest.getRequest(this.endPoint + "/sites/" + siteId, null)
            if(site != undefined){
                this.site_type = site.site_type
            }
            this.paymentTypeData = await HTTPRequest.getRequest(component_x.endPoint + "payment_types/get_valid_payment_types", null, null);
        },
        computed: {
            ...mapState(['currentProfile', 'currentApiURL', 'endPoint', 'parameters']),
        },
        components:{
            VueJsonToCsv
        },
        methods: {
            moment,
            filterOption(input, option) {
                return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
            },
            sort(data){
                data.sort(function (a, b) {
                    return a.name.localeCompare(b.name);
                });
            },
            convertToCurrency(num){
                return num.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
            },
            openNotificationWithIcon(type, title, msg) {
                this.$notification[type]({
                    message: title,
                    description: msg 
                });
            },
            isJsonString(str) {
                try {
                    var json = JSON.parse(str);
                    return (typeof json === 'object');
                } catch (e) {
                    return false;
                }
            },
            generateReport: async function () {
                this.spinning= true;
                let from_date = this.inputDate[0].format('YYYY-MM-DD HH:mm:ss');
                let to_date = this.inputDate[1].format('YYYY-MM-DD HH:mm:ss');

                let trans_val = this.transOptions.find(x => x.key === this.inputTrans).value
                let group_text = ""
                if(this.inputGroupBy != ''){
                    group_text = " by " + this.groupOptions.find(x => x.key === this.inputGroupBy).value
                }

                var get_request = await HTTPRequest.getRequest(this.endPoint + 'pos_activity_report?site_id=' + this.inputSite + '&date_from=' + from_date + '&date_to=' + to_date + '&group=' + this.inputGroupBy + '&trans_code=' + this.inputTrans, null);
                let reportLogo = document.getElementById('reportLogo');

                if(this.inputDate.length == 0){
                    this.openNotificationWithIcon('error', 'Export Error', 'Please make sure to check your current filters.');
                    return
                }

                var siteSpecific = get_request;
                if(siteSpecific.length > 0){
                    let field_count = 4
                    let plus = 30
                    if(this.inputGroupBy == 'session_id'){
                        field_count = 3
                        plus = 10
                    }

                    let doc = new jsPDF({ orientation: 'landscape', unit: 'mm', format: 'legal' });
                    let remaining_width = 0
                    
                    if(siteSpecific[0].report_details[0].data != "null" && siteSpecific[0].report_details[0].data != null){
                        let no_fields = JSON.parse(siteSpecific[0].report_details[0].data)
                        if(this.isJsonString(no_fields) == true){
                            no_fields = JSON.parse(no_fields)   
                        }
                        
                        for (let key of Object.keys(no_fields)) {
                            field_count = field_count + 1
                        }
                    }
                    
                    console.log("here")

                    if(field_count <= 10){
                        remaining_width = (10 - field_count) * 30
                    } else if(field_count <= 12) {
                        doc = new jsPDF({ orientation: 'landscape', unit: 'mm', format: 'a3'});
                        remaining_width = (12 - field_count + plus) * 30
                    } else if(field_count <= 15) {
                        doc = new jsPDF({ orientation: 'landscape', unit: 'mm', format: 'b3'});
                        remaining_width = (15 - field_count + plus) * 30
                    } else {
                        doc = new jsPDF({ orientation: 'landscape', unit: 'mm', format: 'a2'});
                        remaining_width = (23 - field_count + plus) * 30
                    }

                    doc.addImage(reportLogo, "PNG", 15, 0, 15, 15);
                    doc.setFontSize(14);
                    doc.setFontType("bold");
                    let group_val = this.groupOptions.find(x => x.key === this.inputGroupBy).value
                    let trans_val = this.transOptions.find(x => x.key === this.inputTrans).value
                    design_y = 20
                    design_x = 340

                    if(field_count <= 10){
                        //follow default
                    } else if(field_count <= 12) {
                        design_x = 400
                    } else if(field_count <= 15) {
                        design_x = 490
                    } else {
                        design_x = 580
                    }
                    
                    doc.text(15,design_y,`POS ${trans_val} Report by ${group_val}`)
                    doc.setFontType("normal");
                    doc.setFontSize(10);
                    design_y = design_y + 5;
                    doc.text(15,design_y,"Date Range: " + this.inputDate[0].format('MMMM DD, YYYY hh:mm A')  + " to " + this.inputDate[1].format('MMMM DD, YYYY hh:mm A'))

                    // display payment type name instead of code
                    const paymentMap = Object.fromEntries(
                        this.paymentTypeData.map(p => [p.code, p.name])
                    )

                    for(var x=0; x < siteSpecific.length; x++){
                        if(x > 0){
                            //add new page
                            doc.addPage();
                        }

                        let design_y = 20
                        let design_x = 340
                        design_y = design_y + 10;
                        doc.text(15,design_y,"Site Name: " + siteSpecific[x].report_details[0].site_name)

                        this.birSalesReports = siteSpecific[x].report_details
                        const hideSupervisorOverride = this.transCodeWithoutSupervisorOverride.includes(this.inputTrans);

                        let grouper = ''
                        
                        let initial_index = 3
                        let detailColStyles = {
                            0: {cellWidth: 30},
                            1: {cellWidth: 40},
                            2: {cellWidth: 40},
                            3: {cellWidth: 40 },
                        } 
                        
                        if(this.inputGroupBy == 'session_id'){
                            detailColStyles = {
                                0: {cellWidth: 30},
                                1: {cellWidth: 40},
                                2: {cellWidth: 50 }
                            } 
                            initial_index = 2
                        }
                        
                        let dynamic_header = []
                        if(this.inputGroupBy == 'terminal_id'){
                            dynamic_header = [
                                {content: 'Business Date', styles: {halign: 'center'}},
                                {content: 'Timestamp', styles: {halign: 'center'}},
                                {content: 'User', styles: {halign: 'center'}}
                            ]
                            if (!hideSupervisorOverride) {
                                dynamic_header.push({content: 'Supervisor Code', styles: {halign: 'center'}})
                            }
                        } else if (this.inputGroupBy == 'user_id'){
                            dynamic_header = [
                                {content: 'Business Date', styles: {halign: 'center'}},
                                {content: 'Timestamp', styles: {halign: 'center'}},
                                {content: 'Terminal', styles: {halign: 'center'}},
                            ]
                            if (!hideSupervisorOverride) {
                                dynamic_header.push({content: 'Supervisor Code', styles: {halign: 'center'}})
                            }
                        } else if (this.inputGroupBy == 'session_id'){
                            dynamic_header = [
                                {content: 'Business Date', styles: {halign: 'center'}},
                                {content: 'Timestamp', styles: {halign: 'center'}},
                            ]
                            if (!hideSupervisorOverride) {
                                dynamic_header.push({content: 'Supervisor Code', styles: {halign: 'center'}})
                            }
                        }
                        
                        if(siteSpecific[x].report_details[0].data != "null" && siteSpecific[x].report_details[0].data != null){
                            if (this.inputTrans != 'SAUTH') {
                                const parsed = this.parseNestedJSON(siteSpecific[x].report_details[0].data)
                                Object.keys(parsed).forEach(key => {
                                initial_index = initial_index + 1
                                const headerLabel = this.formatHeader(key)
                                dynamic_header.push({content: headerLabel, styles: { halign: 'center' }})
                                detailColStyles[initial_index] = { cellWidth: 30 }
                                })
                            }
                        }

                        if(this.birSalesReports.length > 0){
                            let reportData = []

                            for(let i=0; i < this.birSalesReports.length; i++){
                                let reportLine = this.birSalesReports[i]

                                //body
                                let detail = []
                                if (this.inputTrans == 'SAUTH'){
                                 detail = [
                                        {content: reportLine.site_name, styles: {halign: 'center'}},
                                        {content: reportLine.terminal_id, styles: {halign: 'center'}},
                                        {content: moment(reportLine.business_date).format('MM/DD/YYYY'), styles: {halign: 'center'}},
                                        {content: moment(reportLine.date).format('MM/DD/YYYY hh:mm:ss a'), styles: {halign: 'center'}},
                                        {content: reportLine.manager, styles: {halign: 'center'}},
                                        {content: reportLine.order_no, styles: {halign: 'center'}},
                                        {content: reportLine.module, styles: {halign: 'left'}},
                                    ]
                                } else if(this.inputGroupBy == 'terminal_id'){
                                    detail = [
                                        {content: moment(reportLine.business_date).format('MM/DD/YYYY'), styles: {halign: 'center'}},
                                        {content: moment(reportLine.date).format('MM/DD/YYYY hh:mm:ss a'), styles: {halign: 'center'}},
                                        {content: reportLine.cashier_name, styles: {halign: 'center'}},
                                    ]
                                    if (!hideSupervisorOverride) {
                                        detail.push({content: reportLine.supervisor_code, styles:{halign:'center'}})
                                    }
                                } else if (this.inputGroupBy == 'user_id'){
                                    detail = [
                                        {content: moment(reportLine.business_date).format('MM/DD/YYYY'), styles: {halign: 'center'}},
                                        {content: moment(reportLine.date).format('MM/DD/YYYY hh:mm:ss a'), styles: {halign: 'center'}},
                                        {content: reportLine.terminal_name, styles: {halign: 'center'}},
                                    ]
                                    if (!hideSupervisorOverride) {
                                        detail.push({content: reportLine.supervisor_code, styles:{halign:'center'}})
                                    }
                                } else if (this.inputGroupBy == 'session_id'){
                                    detail = [
                                        {content: moment(reportLine.business_date).format('MM/DD/YYYY'), styles: {halign: 'center'}},
                                        {content: moment(reportLine.date).format('MM/DD/YYYY hh:mm:ss a'), styles: {halign: 'center'}},
                                    ]
                                    if (!hideSupervisorOverride) {
                                        detail.push({content: reportLine.supervisor_code, styles:{halign:'center'}})
                                    }
                                }
                                
                                let additional_values = JSON.parse(reportLine.data)
                                if(additional_values == null){
                                    detail.push('')
                                } else {
                                    if (this.inputTrans !== 'SAUTH') {
                                        const parsed = this.parseNestedJSON(additional_values)
                                        const orderedKeys = Object.keys(parsed)
                                        const buildHeader = dynamic_header.length === 0
                                        if (this.inputTrans !== 'PAY') {
                                            orderedKeys.forEach(key => {
                                                if (buildHeader) {
                                                    dynamic_header.push({content: this.formatHeader(key),styles: { halign: 'center' }})
                                                }
                                                detail.push({
                                                    content: (parsed[key] !== null && parsed[key] !== undefined)
                                                    ? parsed[key]
                                                    : '',
                                                    styles: { halign: 'center' }
                                                })
                                            })
                                        } else {
                                            orderedKeys.forEach(key => {
                                            if (buildHeader) {
                                                dynamic_header.push({
                                                    content: this.formatHeader(key),
                                                    styles: { halign: 'center' }
                                                })
                                            }
                                            let value = parsed[key]
                                            // translate payment_type code to name
                                            if (key === 'paymentType') {
                                                value = paymentMap[value] || value
                                            }
                                            detail.push({
                                                content: (value !== null && value !== undefined) ? value : '',
                                                styles: { halign: 'center' }
                                            })
                                        })
                                        }
                                    }
                                }

                                if(this.inputGroupBy == 'terminal_id'){
                                    if(grouper == ''){
                                        design_y = design_y + 5;
                                        doc.text(15,design_y,"Terminal Name: " + reportLine.terminal_name)
                                    } else {
                                        if(grouper != reportLine.terminal_id){
                                            //if new terminal display prev terminal details
                                            design_y = design_y + 5
                                            doc.autoTable({
                                                startY: design_y, 
                                                head: [dynamic_header],
                                                body: reportData, 
                                                theme: 'plain',
                                                tableWidth: 'wrap',
                                                headStyles: {
                                                    lineWidth: 0.15
                                                },
                                                styles: {
                                                    cellPadding: 1.0, fontSize: 9,
                                                    halign: 'center'
                                                },
                                                columnStyles: detailColStyles
                                            });
                                            reportData = [];  
                                            //add new page
                                            doc.addPage();

                                            design_y = 20;
                                            doc.text(15,design_y,"Terminal Name: " + reportLine.terminal_name)
                                        }
                                    }
                                    grouper = reportLine.terminal_id
                                } else if (this.inputGroupBy == 'user_id'){
                                    if(grouper == ''){
                                        design_y = design_y + 5;
                                        doc.text(15,design_y,"Cashier Name: " + reportLine.cashier_name)
                                    } else {
                                        if(grouper != reportLine.user_id){
                                            //if new cashier display prev cashier details
                                            design_y = design_y + 5
                                            doc.autoTable({
                                                startY: design_y, 
                                                head: [dynamic_header],
                                                body: reportData, 
                                                theme: 'plain',
                                                tableWidth: 'wrap',
                                                headStyles: {
                                                    lineWidth: 0.15
                                                },
                                                styles: {
                                                    cellPadding: 1.0, fontSize: 9,
                                                    halign: 'center'
                                                },
                                                columnStyles: detailColStyles
                                            });
                                            reportData = [];  
                                            //add new page
                                            doc.addPage();

                                            design_y = 20;
                                            doc.text(15,design_y,"Cashier Name: " + reportLine.cashier_name)
                                        }
                                    }
                                    grouper = reportLine.user_id
                                } else if (this.inputGroupBy == 'session_id'){
                                    if(grouper == ''){
                                        design_y = design_y + 5;
                                        doc.text(15,design_y,"Session ID: " + reportLine.session_id)

                                        design_y = design_y + 5;
                                        doc.text(15,design_y,"Cashier Name: " + reportLine.cashier_name)

                                        design_y = design_y + 5;
                                        doc.text(15,design_y,"Terminal Name: " + reportLine.terminal_name)
                                    } else {
                                        if(grouper != reportLine.session_id){
                                            //if new session display prev session details
                                            design_y = design_y + 5
                                            doc.autoTable({
                                                startY: design_y, 
                                                head: [dynamic_header],
                                                body: reportData, 
                                                theme: 'plain',
                                                tableWidth: 'wrap',
                                                headStyles: {
                                                    lineWidth: 0.15
                                                },
                                                styles: {
                                                    cellPadding: 1.0, fontSize: 9,
                                                    halign: 'center'
                                                },
                                                columnStyles: detailColStyles
                                            });

                                            //add new page
                                            doc.addPage();

                                            design_y = 20;
                                            doc.text(15,design_y,"Session ID: " + reportLine.session_id)

                                            design_y = design_y + 5;
                                            doc.text(15,design_y,"Cashier Name: " + reportLine.cashier_name)

                                            design_y = design_y + 5;
                                            doc.text(15,design_y,"Terminal Name: " + reportLine.terminal_name)
                                        }
                                    }
                                    grouper = reportLine.session_id
                                }

                                reportData.push(detail)

                                if(i == this.birSalesReports.length-1){
                                    design_y = design_y + 5
                                    doc.autoTable({
                                        startY: design_y, 
                                        head: [dynamic_header],
                                        body: reportData, 
                                        theme: 'plain',
                                        tableWidth: 'wrap',
                                        headStyles: {
                                            lineWidth: 0.15
                                        },
                                        styles: {
                                            cellPadding: 1.0, fontSize: 9,
                                            halign: 'center'
                                        },
                                        columnStyles: detailColStyles
                                    });
                                }
                            }
                        }
                    }

                    let printed_by = secureStorage.getItem("email")
                    if(printed_by == null){
                        printed_by = ''
                    }

                    let pageCount = doc.internal.getNumberOfPages();
                    let design_x = 340
                    let design_y = 205

                    for(let i = 1; i <= pageCount; i++) { 
                        doc.setPage(i);
                        // doc.text(340,210,"Page " + doc.internal.getCurrentPageInfo().pageNumber  + " of " + pageCount, "right")
                        reportUtils.pdfTools.addFooter(doc, printed_by, `POS ${trans_val} Report by ` + group_text, design_x, design_y, i, pageCount)
                    }

                    // doc.save(`POS_Activity_${this.inputTrans}_Report_${moment().format('YYYYMMDDHHmmss')}.pdf`);
                    window.open(URL.createObjectURL(doc.output("blob")))
                } else {
                    this.openNotificationWithIcon('info', 'No Data Found', 'Please make sure to check your current filters.');
                }
                this.spinning= false;
            },
            generateFile: async function() {
                this.spinning= true;
                let from_date = this.inputDate[0].format('YYYY-MM-DD HH:mm:ss');
                let to_date = this.inputDate[1].format('YYYY-MM-DD HH:mm:ss');
                let from_header = this.inputDate[0].format('MMMM DD, YYYY')
                let to_header = this.inputDate[1].format('MMMM DD, YYYY')
                let trans_val = this.transOptions.find(x => x.key === this.inputTrans).value

                var get_request = await HTTPRequest.getRequest(this.endPoint + 'pos_activity_report?site_id=' + this.inputSite + '&date_from=' + from_date + '&date_to=' + to_date + '&group=' + this.inputGroupBy + '&trans_code=' + this.inputTrans, null);

                if(this.inputDate.length == 0){
                    this.openNotificationWithIcon('error', 'Export Error', 'Please make sure to check your current filters.');
                    return
                }

                var siteSpecific = get_request;
                if(siteSpecific.length > 0){
                    let headers = [];
                    let site_specific = [];
                    let field_count = 5
                    let plus = 30
                    if(this.inputGroupBy == 'session_id'){
                        field_count = 4
                        plus = 10
                    }

                    let remaining_width = 0

                    const paymentMap = Object.fromEntries(
                        this.paymentTypeData.map(p => [p.code, p.name])
                    )
                    
                    if(siteSpecific[0].report_details[0].data != "null" && siteSpecific[0].report_details[0].data != null){
                        let no_fields = JSON.parse(siteSpecific[0].report_details[0].data)
                        if(this.isJsonString(no_fields) == true){
                            no_fields = JSON.parse(no_fields)   
                        }
                        
                        for (let key of Object.keys(no_fields)) {
                            field_count = field_count + 1
                        }
                    }

                    for(let x=0; x < siteSpecific.length; x++){
                        this.birSalesReports = siteSpecific[x].report_details

                        let grouper = ''
                        
                        let initial_index = 3
                        
                        if(this.inputGroupBy == 'session_id'){
                            initial_index = 2
                        }
                        
                        const hideSupervisorOverride = this.transCodeWithoutSupervisorOverride.includes(this.inputTrans);
                        let dynamic_header = []
                        if(this.inputTrans == 'SAUTH'){
                             dynamic_header = ['Site','Terminal ID', 'Business Date','Timestamp','Supervisor Name','Order No','Module']
                        } else if(this.inputGroupBy == 'terminal_id'){
                            dynamic_header = [ 'Site Name', 'Business Date','Timestamp','User']
                            if (!hideSupervisorOverride) {
                                dynamic_header.push('Supervisor Code')
                            }
                        } else if (this.inputGroupBy == 'user_id'){
                            dynamic_header = [ 'Site Name', 'Business Date','Timestamp','Terminal']
                            if (!hideSupervisorOverride) {
                                dynamic_header.push('Supervisor Code')
                            }
                        } else if (this.inputGroupBy == 'session_id'){
                            dynamic_header = [ 'Site Name', 'Business Date','Timestamp',]
                            if (!hideSupervisorOverride) {
                                dynamic_header.push('Supervisor Code')
                            }
                        }
                        let reportData = []
                        if(siteSpecific[x].report_details[0].data != "null" && siteSpecific[x].report_details[0].data != null){
                            if (this.inputTrans != 'SAUTH') {
                                const parsed = this.parseNestedJSON(siteSpecific[x].report_details[0].data)
                                Object.keys(parsed).forEach(key => {
                                initial_index = initial_index + 1
                                const headerLabel = this.formatHeader(key)
                                dynamic_header.push(headerLabel)
                                })
                            }
                        }
                        headers = dynamic_header
                        if(this.birSalesReports.length > 0){

                            for(let i=0; i < this.birSalesReports.length; i++){
                                let reportLine = this.birSalesReports[i]

                                //body
                                let detail = []
                                if (this.inputTrans == 'SAUTH') {
                                    detail = [reportLine.site_name, reportLine.terminal_id, moment(reportLine.business_date).format('MM/DD/YYYY'), moment(reportLine.date).format('MM/DD/YYYY hh:mm:ss a'), reportLine.manager, reportLine.order_no, reportLine.module]
                                } else if(this.inputGroupBy == 'terminal_id'){
                                    detail = [reportLine.site_name, moment(reportLine.business_date).format('MM/DD/YYYY'),moment(reportLine.date).format('MM/DD/YYYY hh:mm:ss a'),reportLine.cashier_name]
                                    if (!hideSupervisorOverride) {
                                        detail.push(reportLine.supervisor_code)
                                    }
                                } else if (this.inputGroupBy == 'user_id'){
                                    detail = [reportLine.site_name, moment(reportLine.business_date).format('MM/DD/YYYY'),moment(reportLine.date).format('MM/DD/YYYY hh:mm:ss a'),reportLine.terminal_name]
                                    if (!hideSupervisorOverride) {
                                        detail.push(reportLine.supervisor_code)
                                    }
                                } else if (this.inputGroupBy == 'session_id'){
                                    detail = [reportLine.site_name, moment(reportLine.business_date).format('MM/DD/YYYY'), moment(reportLine.date).format('MM/DD/YYYY hh:mm:ss a')]
                                    if (!hideSupervisorOverride) {
                                        detail.push(reportLine.supervisor_code)
                                    }
                                }
                                if (this.inputTrans !== 'SAUTH') {
                                    const parsed = this.parseNestedJSON(reportLine.data)
                                    if (!parsed || Object.keys(parsed).length === 0) {
                                        detail.push('')
                                    } else {
                                        Object.keys(parsed).forEach(key => {
                                            let value = parsed[key]
                                            // translate payment code to payment name
                                            if (this.inputTrans === 'PAY' && value in paymentMap) {
                                                value = paymentMap[value]
                                            }
                                            detail.push(value !== null && value !== undefined ? String(value) : '')
                                        })
                                    }
                                }
                                reportData.push(detail)
                            }
                        }
                        

                        let group_text = ""
                        if(this.inputGroupBy != ''){
                            group_text = " by " + this.groupOptions.find(x => x.key === this.inputGroupBy).value
                        }


                        let printed_by = secureStorage.getItem("email")
                        if(printed_by == null){
                            printed_by = ''
                        }

                        reportData.push([])
                        reportData.push([`POS ${trans_val} Report by ` + group_text, "Generated By: " + printed_by,"","","","For the Period of " + from_header + " to " + to_header])
                        reportData.push([])

                        let keys = headers;
                        let values = reportData;
                        var values_length = values.length;

                        let newJsonData=[];

                        // change headers and report data as key and value object
                        for(var i=0;i < values_length; i++){
                        	var result =  Object.assign.apply({}, keys.map( (val, index) => ( {
                              		[val]: values[i][index]
                            	  }
                              )
                            )
                          );
                          newJsonData.push(result)
                        }

                        // change undefined on arr
                        newJsonData.forEach(function(obj) {
                          for(var i in obj) {
                            if(obj[i] === undefined || obj[i] === null ) {
                              obj[i] = '';
                            }
                          }
                        });
                        site_specific.push(newJsonData)
                        // this.JsonData = site_specific;
                    }
                    this.JsonData = site_specific.flat(Infinity);
                } else {
                    this.openNotificationWithIcon('info', 'No Data Found', 'Please make sure to check your current filters.');
                }
                this.spinning= false;
            },
            clearJsonData(){
              // console.log("working",this.JsonData)
              this.JsonData = [];
            },
            parseNestedJSON(value) {
                if (!value) return {}
                try {
                    const first = typeof value === 'string' ? JSON.parse(value) : value
                    return typeof first === 'string' ? JSON.parse(first) : first
                } catch (e) {
                    return {}
                }
            },
            formatHeader(key) {
                if (!key) return ''
                return key
                    // convert snake_case to spaces
                    .replace(/_/g, ' ')
                    // convert camelCase to spaces
                    .replace(/([a-z])([A-Z])/g, '$1 $2')
                    // normalize spacing
                    .toLowerCase()
                    // title case
                    .replace(/\b\w/g, char => char.toUpperCase())
            },
        }
    };
</script>

<style></style>
